import { register } from "./Registry"

register('product-form', () => {
	const form = document.querySelector('form.shopify-product-form')
	if (!form) return
	
	const variants = form.querySelectorAll<HTMLDivElement>('div.variants div.variant')
	const hiddenInput = form.querySelector<HTMLInputElement>('input[name="id"]')

	variants.forEach(variant => variant.addEventListener('click', () => {
		const id = variant.dataset.id!
        if (hiddenInput) hiddenInput.value = id

        const url = new URL(window.location.href)
    	url.searchParams.set('variant', id)
        window.location.href = url.toString()
	}))
})

register('product-image-slider', () => {
    const slider = document.querySelector<HTMLElement>('.product-image-slider')
    if (!slider) return

    const slides = Array.from(slider.querySelectorAll<HTMLElement>('.slide'))
    const thumbnails = Array.from(slider.querySelectorAll<HTMLButtonElement>('.thumbnail'))
    const prev = slider.querySelector<HTMLButtonElement>('.slider-arrow.prev')
    const next = slider.querySelector<HTMLButtonElement>('.slider-arrow.next')

    if (slides.length === 0) return

    let index = slides.findIndex(s => s.classList.contains('active'))
    if (index < 0) index = 0

    function show(i: number) {
        if (i < 0) i = slides.length - 1
        if (i >= slides.length) i = 0

        slides.forEach(s => s.classList.remove('active'))
        thumbnails.forEach(t => t.classList.remove('active'))

        slides[i].classList.add('active')

        const mediaId = slides[i].dataset.mediaId
        const thumb = thumbnails.find(t => t.dataset.mediaId === mediaId)
        thumb?.classList.add('active')

        index = i
    }

    prev?.addEventListener('click', () => show(index - 1))
    next?.addEventListener('click', () => show(index + 1))

    thumbnails.forEach((thumb, i) => {
        thumb.addEventListener('click', () => show(i))
    })
})